/** The number badge a main rail tile shows while the shortcut modifier is held.
 *  Sits over the tile's bottom-left corner, which suits both the 36px and the 28px tile.
 *  Literal colours: the badge must read the same on every rail material and theme. */

export function MainRailShortcutHint({ number }: { number: number }) {
  return (
    <span
      data-slot="main-rail-shortcut-hint"
      aria-hidden="true"
      className="pointer-events-none absolute -bottom-1 -left-1 z-10 flex h-4 min-w-4 items-center justify-center rounded-[4px] bg-[#E8E8E8] px-[3px] text-[10px] font-bold leading-none tabular-nums text-[#1D1C1D] shadow-[0_0_0_1px_rgba(0,0,0,0.12),0_1px_2px_rgba(0,0,0,0.18)]"
    >
      {number}
    </span>
  );
}
